import React from "react";

import styles from "./HeaderMiddle.module.scss";
import { Link } from "react-router";
import Modal from "../../../../UI/Modal/Modal";

const isViewData = [
  { id: 0, text: "бельевые", link: "/catalog" },
  { id: 1, text: "блузочные", link: "/catalog" },
  { id: 2, text: "верхняя одежда", link: "/catalog" },
  { id: 3, text: "вечерние", link: "/catalog" },
  { id: 4, text: "детские", link: "/catalog" },
  { id: 5, text: "для дома", link: "/catalog" },
  { id: 6, text: "костюмные", link: "/catalog" },
  { id: 7, text: "плательные", link: "/catalog" },
  { id: 8, text: "подкладочные", link: "/catalog" },
  { id: 9, text: "рубашечные", link: "/catalog" },
  { id: 10, text: "спортивные", link: "/catalog" },
  { id: 11, text: "сценические", link: "/catalog" },
  { id: 12, text: "эксклюзивные", link: "/catalog" },
  { id: 13, text: "", link: "/catalog" },
  { id: 14, text: "", link: "/catalog" },
];
const isPictureData = [
  { id: 0, text: "3D", link: "/catalog" },
  { id: 1, text: "Горошки", link: "/catalog" },
  { id: 2, text: "Капли", link: "/catalog" },
  { id: 3, text: "Полоска", link: "/catalog" },
  { id: 4, text: "Съедобные", link: "/catalog" },
  { id: 5, text: "ЗигЗаг", link: "/catalog" },
  { id: 6, text: "Градиент", link: "/catalog" },
  { id: 7, text: "Клетка", link: "/catalog" },
  { id: 8, text: "Предметы", link: "/catalog" },
  { id: 9, text: "Транспорт", link: "/catalog" },
  { id: 11, text: "Граффити", link: "/catalog" },
  { id: 12, text: "Круги", link: "/catalog" },
  { id: 13, text: "Птицы", link: "/catalog" },
  { id: 14, text: "Узор", link: "/catalog" },
  { id: 15, text: "Объёмный рисунок", link: "/catalog" },
  { id: 16, text: "Детские", link: "/catalog" },
  { id: 17, text: "Лица", link: "/catalog" },
  { id: 18, text: "Пятна", link: "/catalog" },
  { id: 19, text: "Цветочки", link: "/catalog" },
  { id: 20, text: "Абстракция", link: "/catalog" },
  { id: 21, text: "Звезды", link: "/catalog" },
  { id: 22, text: "Надписи", link: "/catalog" },
  { id: 23, text: "Пёрышки", link: "/catalog" },
  { id: 24, text: "Цветы", link: "/catalog" },
  { id: 25, text: "Буквы", link: "/catalog" },
  { id: 26, text: "Звериные", link: "/catalog" },
  { id: 27, text: "Насекомые", link: "/catalog" },
  { id: 28, text: "Растительные", link: "/catalog" },
  { id: 29, text: "Цепи", link: "/catalog" },
  { id: 30, text: "Геометрия", link: "/catalog" },
  { id: 31, text: "Зебра", link: "/catalog" },
  { id: 32, text: "Новогодние", link: "/catalog" },
  { id: 33, text: "Сердечки", link: "/catalog" },
  { id: 34, text: "Штрихи", link: "/catalog" },
  { id: 35, text: "Горох", link: "/catalog" },
  { id: 36, text: "Камуфляж", link: "/catalog" },
  { id: 37, text: "Орнамент", link: "/catalog" },
  { id: 38, text: "Спорт", link: "/catalog" },
  { id: 39, text: "Ёлочка", link: "/catalog" },
  { id: 10, text: "Индийские огурцы (пейсли)", link: "/catalog" },
];
const isColorData = [
  { id: 0, text: "Желтые", color: "#FFFF00", link: "/catalog" },
  { id: 1, text: "Зелёные", color: "#00FF00", link: "/catalog" },
  { id: 2, text: "Фиолетовые", color: "#800080", link: "/catalog" },
  { id: 3, text: "Мультиколор", color: "#B9D335", link: "/catalog" },
  { id: 4, text: "Терракотовый", color: "#E2725B", link: "/catalog" },
  { id: 5, text: "Бордовые", color: "#800000", link: "/catalog" },
  { id: 6, text: "Красные", color: "#FF0000", link: "/catalog" },
  { id: 7, text: "Бирюзовые", color: "#40E0D0", link: "/catalog" },
  { id: 8, text: "Голубые", color: "#80A6FF", link: "/catalog" },
  { id: 9, text: "Коралловый", color: "#FF7F50", link: "/catalog" },
  { id: 10, text: "Розовые", color: "#FF69B4", link: "/catalog" },
  { id: 11, text: "Коричневые", color: "#3E2908", link: "/catalog" },
  { id: 12, text: "Черные", color: "#000000", link: "/catalog" },
  { id: 13, text: "Бежевый", color: "#FFE6B5", link: "/catalog" },
  { id: 14, text: "Чёрно-белый", color: "#818181", link: "/catalog" },
  { id: 15, text: "Нюдовые", color: "#DBBDA7", link: "/catalog" },
  { id: 16, text: "Светлые", color: "#F2F0E2", link: "/catalog" },
  { id: 17, text: "Белые", color: "#FFFFFF", link: "/catalog" },
  { id: 18, text: "Фуксия", color: "#FF00FF", link: "/catalog" },
  { id: 19, text: "Оранжевые", color: "#FAB428", link: "/catalog" },
  { id: 20, text: "Синие", color: "#3366FF", link: "/catalog" },
  { id: 21, text: "Серые", color: "#CDCDCD", link: "/catalog" },
  { id: 22, text: "Хаки", color: "#788769", link: "/catalog" },
  { id: 23, text: "", color: "", link: "/catalog" },
  { id: 24, text: "", color: "", link: "/catalog" },
];

const isAlphabetData = [
  { id: 1, text: "Тканополис", link: "/catalog" },
  { id: 2, text: "Жаккард", link: "/catalog" },
  { id: 3, text: "Неопрен", link: "/catalog" },
  { id: 4, text: "Сорочечная", link: "/catalog" },
  { id: 5, text: "Фатин", link: "/catalog" },
  { id: 6, text: "Атлас", link: "/catalog" },
  { id: 7, text: "Замша", link: "/catalog" },
  { id: 8, text: "Органза", link: "/catalog" },
  { id: 9, text: "Тафта", link: "/catalog" },
  { id: 10, text: "Фланель", link: "/catalog" },
  { id: 11, text: "Бархат", link: "/catalog" },
  { id: 12, text: "Костюмные ткани", link: "/catalog" },
  { id: 13, text: "Пайетки", link: "/catalog" },
  { id: 14, text: "Твид", link: "/catalog" },
  { id: 15, text: "Флис", link: "/catalog" },
  { id: 16, text: "Батист", link: "/catalog" },
  { id: 17, text: "Котон", link: "/catalog" },
  { id: 18, text: "Пальтовые ткани", link: "/catalog" },
  { id: 19, text: "Твил", link: "/catalog" },
  { id: 20, text: "Футер", link: "/catalog" },
  { id: 21, text: "Бифлекс", link: "/catalog" },
  { id: 22, text: "Креп", link: "/catalog" },
  { id: 23, text: "Парча", link: "/catalog" },
  { id: 24, text: "Тенсель", link: "/catalog" },
  { id: 25, text: "Хлопок", link: "/catalog" },
  { id: 26, text: "Букле", link: "/catalog" },
  { id: 27, text: "Кружево", link: "/catalog" },
  { id: 28, text: "Плательные ткани", link: "/catalog" },
  { id: 29, text: "Ткани Италии", link: "/catalog" },
  { id: 30, text: "Шёлк искусственный", link: "/catalog" },
  { id: 31, text: "Велсофт", link: "/catalog" },
  { id: 32, text: "Купра", link: "/catalog" },
  { id: 33, text: "Платки", link: "/catalog" },
  { id: 34, text: "Трикотаж", link: "/catalog" },
  { id: 35, text: "Шёлк натуральный", link: "/catalog" },
  { id: 36, text: "Вельвет", link: "/catalog" },
  { id: 37, text: "Курточные ткани", link: "/catalog" },
  { id: 38, text: "Плащевка", link: "/catalog" },
  { id: 39, text: "Трикотаж бельевой", link: "/catalog" },
  { id: 40, text: "Шифон", link: "/catalog" },
  { id: 41, text: "Велюр", link: "/catalog" },
  { id: 42, text: "Лайкра", link: "/catalog" },
  { id: 43, text: "Подкладочные ткани", link: "/catalog" },
  { id: 44, text: "Трикотаж Кашкорсе", link: "/catalog" },
  { id: 45, text: "Эко-кожа", link: "/catalog" },
  { id: 46, text: "Вуаль", link: "/catalog" },
  { id: 47, text: "Марлевка", link: "/catalog" },
  { id: 48, text: "Прошва", link: "/catalog" },
  { id: 49, text: "Трикотаж лапша", link: "/catalog" },
  { id: 50, text: "", link: "/catalog" },
  { id: 51, text: "Джерси", link: "/catalog" },
  { id: 52, text: "Мех", link: "/catalog" },
  { id: 53, text: "Сатин", link: "/catalog" },
  { id: 54, text: "Трикотаж масло", link: "/catalog" },
  { id: 55, text: "", link: "/catalog" },
  { id: 56, text: "Джинс", link: "/catalog" },
  { id: 57, text: "Муслин", link: "/catalog" },
  { id: 58, text: "Сетка", link: "/catalog" },
  { id: 59, text: "Утеплитель", link: "/catalog" },
  { id: 60, text: "", link: "/catalog" },
];
const isFittingsData = [
  { id: 0, text: "Карабины", link: "/catalog" },
  { id: 1, text: "Кнопки", link: "/catalog" },
  { id: 2, text: "Нейлоп", link: "/catalog" },
  { id: 3, text: "Фиксаторы", link: "/catalog" },
  { id: 4, text: "Швейные принадлежности", link: "/catalog" },
  { id: 5, text: "Булавки", link: "/catalog" },
  { id: 6, text: "Косая бейка", link: "/catalog" },
  { id: 7, text: "Молнии", link: "/catalog" },
  { id: 8, text: "Разделители", link: "/catalog" },
  { id: 9, text: "Шнуры", link: "/catalog" },
  { id: 10, text: "Декора для одежды", link: "/catalog" },
  { id: 11, text: "Кружево", link: "/catalog" },
  { id: 12, text: "Пуговицы", link: "/catalog" },
  { id: 13, text: "Треугольные фурнитура", link: "/catalog" },
  { id: 14, text: "Перья и Боа", link: "/catalog" },
  { id: 15, text: "Клеевые материалы", link: "/catalog" },
  { id: 16, text: "Ленты", link: "/catalog" },
  { id: 17, text: "Пуговицы", link: "/catalog" },
  { id: 18, text: "", link: "/catalog" },
  { id: 19, text: "", link: "/catalog" },
];
const isWholesaleData = [
  { id: 0, text: "Китай", link: "/catalog" },
  { id: 1, text: "Турция", link: "/catalog" },
  { id: 2, text: "Курпный опт", link: "/catalog" },
];

const HeaderMiddle: React.FC = () => {
  const [searchTitle, setSearchTitle] = React.useState("Везде");
  const [isSearchMenuActive, setIsSearchMenuActive] = React.useState(false);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const [isCatalogMenuActive, setIsCatalogMenuActive] = React.useState(false);
  const [isCatalogLinksActive, setIsCatalogLinksActive] = React.useState({
    isView: false,
    isPicture: false,
    isColor: false,
    isAlphabet: false,
    isFittings: false,
    isWholesale: false,
  });
  const searchButtonRef = React.useRef<HTMLButtonElement>(null);
  const catalogRef = React.useRef<HTMLDivElement>(null);

  const [isRegAuthModalActive, setIsRegAuthModalActive] = React.useState(false);


  React.useEffect(() => {
    const handleSearchClickOutside = (event: MouseEvent) => {
      if (searchButtonRef.current && !searchButtonRef.current.contains(event.target as Node)) {
        setIsSearchMenuActive(false);
      }
    };

    if (isSearchMenuActive) {
      document.addEventListener("click", handleSearchClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleSearchClickOutside);
    };
  }, [isSearchMenuActive]);

  React.useEffect(() => {
    const handleCatalogClickOutside = (event: MouseEvent) => {
      if (catalogRef.current && !catalogRef.current.contains(event.target as Node)) {
        setIsCatalogMenuActive(false);
      }
    };

    if (isCatalogMenuActive) {
      document.addEventListener("click", handleCatalogClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleCatalogClickOutside);
    };
  }, [isCatalogMenuActive]);

  return (
    <div className={styles.middle}>
      <Modal mode="authReg" isActive={isRegAuthModalActive} setIsActive={setIsRegAuthModalActive} />
      <Link to="/" className={styles.logo}>
        <img src="/img/header/logo.svg" alt="Тканополис" />
      </Link>
      <div ref={catalogRef} className={styles.catalog} onClick={() => setIsCatalogMenuActive(!isCatalogMenuActive)}>
        <div className={styles.row}>
          <div className={isCatalogMenuActive ? `${styles.catalogButton} ${styles.active}` : styles.catalogButton}>
            <span />
          </div>
          <span>Каталог</span>
        </div>
        <div className={isCatalogMenuActive ? `${styles.catalogMenu} ${styles.active}` : styles.catalogMenu}>
          <ul className={styles.catalogTitles}>
            <Link to="/catalog">Скидки</Link>
            <li
              className={isCatalogLinksActive.isView ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: true,
                  isPicture: false,
                  isColor: false,
                  isAlphabet: false,
                  isFittings: false,
                  isWholesale: false,
                })
              }
            >
              Вид
            </li>
            <li
              className={isCatalogLinksActive.isPicture ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: false,
                  isPicture: true,
                  isColor: false,
                  isAlphabet: false,
                  isFittings: false,
                  isWholesale: false,
                })
              }
            >
              Рисунок
            </li>
            <li
              className={isCatalogLinksActive.isColor ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: false,
                  isPicture: false,
                  isColor: true,
                  isAlphabet: false,
                  isFittings: false,
                  isWholesale: false,
                })
              }
            >
              Цвет
            </li>
            <li
              className={isCatalogLinksActive.isAlphabet ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: false,
                  isPicture: false,
                  isColor: false,
                  isAlphabet: true,
                  isFittings: false,
                  isWholesale: false,
                })
              }
            >
              По алфавиту
            </li>
            <li
              className={isCatalogLinksActive.isFittings ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: false,
                  isPicture: false,
                  isColor: false,
                  isAlphabet: false,
                  isFittings: true,
                  isWholesale: false,
                })
              }
            >
              Фурнитура
            </li>
            <li
              className={isCatalogLinksActive.isWholesale ? styles.active : ""}
              onMouseEnter={() =>
                setIsCatalogLinksActive({
                  isView: false,
                  isPicture: false,
                  isColor: false,
                  isAlphabet: false,
                  isFittings: false,
                  isWholesale: true,
                })
              }
            >
              Опт
            </li>
            <Link to="/delivery-and-payment">Условия доставки</Link>
          </ul>
          <ul className={styles.catalogLinks}>
            {isCatalogLinksActive.isView && (
              <>
                {isViewData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <p className="animated-underline">{item.text}</p>
                    </Link>
                  </li>
                ))}
              </>
            )}
            {isCatalogLinksActive.isPicture && (
              <>
                {isPictureData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <p className="animated-underline">{item.text}</p>
                    </Link>
                  </li>
                ))}
              </>
            )}
            {isCatalogLinksActive.isColor && (
              <>
                {isColorData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <div className={styles.colors}>
                        <div
                          className={styles.color}
                          style={item.color.length ? { backgroundColor: item.color } : { border: "none" }}
                        />
                        <p className="animated-underline">{item.text}</p>
                      </div>
                    </Link>
                  </li>
                ))}
              </>
            )}
            {isCatalogLinksActive.isAlphabet && (
              <>
                {isAlphabetData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <p className="animated-underline">{item.text}</p>
                    </Link>
                  </li>
                ))}
              </>
            )}
            {isCatalogLinksActive.isFittings && (
              <>
                {isFittingsData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <p className="animated-underline">{item.text}</p>
                    </Link>
                  </li>
                ))}
              </>
            )}
            {isCatalogLinksActive.isWholesale && (
              <>
                {isWholesaleData.map((item) => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      <p className="animated-underline">{item.text}</p>
                    </Link>
                  </li>
                ))}
              </>
            )}
          </ul>
        </div>
      </div>
      <div className={styles.search}>
        <button ref={buttonRef} className={styles.button} onClick={() => setIsSearchMenuActive(!isSearchMenuActive)}>
          {searchTitle}
          <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.84 1L10.32 7.52C9.55 8.29 8.29 8.29 7.52 7.52L1 1"
              stroke="#9D9595"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <ul className={isSearchMenuActive ? `${styles.searchMenu} ${styles.active}` : styles.searchMenu}>
            <li onClick={() => setSearchTitle("Везде")}>Везде</li>
            <li onClick={() => setSearchTitle("В тканях")}>В тканях</li>
            <li onClick={() => setSearchTitle("В фурнитуре")}>В фурнитуре</li>
          </ul>
        </button>
        <input type="text" placeholder="Искать в магазине" />
        <button className={styles.find}>
          <Link to="/catalog">
            <svg width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_23_551)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 16.5C0 12.1239 1.73839 7.92709 4.83274 4.83274C7.92709 1.73839 12.1239 0 16.5 0C20.8761 0 25.0729 1.73839 28.1673 4.83274C31.2616 7.92709 33 12.1239 33 16.5C33 20.8761 31.2616 25.0729 28.1673 28.1673C25.0729 31.2616 20.8761 33 16.5 33C12.1239 33 7.92709 31.2616 4.83274 28.1673C1.73839 25.0729 0 20.8761 0 16.5ZM15.4 8.8C14.3613 8.79987 13.3372 9.04491 12.411 9.51519C11.4848 9.98547 10.6828 10.6677 10.07 11.5064C9.4572 12.3452 9.05103 13.3167 8.88452 14.342C8.718 15.3673 8.79583 16.4174 9.11169 17.4069C9.42754 18.3964 9.97249 19.2975 10.7022 20.0367C11.432 20.7759 12.3259 21.3324 13.3112 21.661C14.2966 21.9896 15.3457 22.081 16.373 21.9278C17.4004 21.7745 18.377 21.3809 19.2236 20.779L22.3234 23.8788L23.8788 22.3234L20.779 19.2236C21.4807 18.2363 21.8973 17.0749 21.9829 15.8666C22.0685 14.6583 21.82 13.4498 21.2645 12.3734C20.709 11.2969 19.868 10.3941 18.8336 9.76385C17.7992 9.13357 16.6113 8.80011 15.4 8.8Z"
                  fill="currentColor"
                />
              </g>
            </svg>
          </Link>
        </button>
      </div>
      <ul className={styles.links}>
        <Link to="/cart" className={styles.item}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.6505 5.53116V4.75483C4.6505 2.95407 6.3052 1.18533 8.36216 1.01726C8.93369 0.968099 9.51065 1.02424 10.0559 1.18208C10.6012 1.33991 11.1026 1.59594 11.528 1.93368C11.9534 2.27142 12.2934 2.6834 12.5259 3.14309C12.7585 3.60278 12.8785 4.10001 12.8783 4.60277V5.70724M6.0218 17H11.507C15.1821 17 15.8403 15.7115 16.0323 14.1428L16.718 9.34077C16.9648 7.38795 16.3249 5.79527 12.4212 5.79527H5.1076C1.20396 5.79527 0.564014 7.38795 0.810849 9.34077L1.4965 14.1428C1.68848 15.7115 2.34671 17 6.0218 17Z"
              stroke="#1C1D20"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.9597 8.99667H11.9689M5.5603 8.99667H5.56762"
              stroke="#1C1D20"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>Корзина</p>
        </Link>
        <Link to="/favorites" className={styles.item}>
          <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0083 15.9242C9.73633 16.0253 9.28833 16.0253 9.01633 15.9242C6.69633 15.0899 1.51233 11.6096 1.51233 5.71067C1.51233 3.10674 3.50433 1 5.96033 1C7.41633 1 8.70433 1.74157 9.51233 2.88764C9.92335 2.3027 10.4587 1.8273 11.0755 1.4995C11.6923 1.17171 12.3735 1.00064 13.0643 1C15.5203 1 17.5123 3.10674 17.5123 5.71067C17.5123 11.6096 12.3283 15.0899 10.0083 15.9242Z"
              stroke="#1C1D20"
              strokeWidth="1.63636"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>Избранное</p>
        </Link>
        <li className={styles.item} onClick={() => setIsRegAuthModalActive(true)}>
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.6616 17C15.6616 13.904 12.5243 11.4 8.66162 11.4C4.79899 11.4 1.66162 13.904 1.66162 17M8.66162 9C9.74225 9 10.7786 8.57857 11.5427 7.82843C12.3068 7.07828 12.7361 6.06087 12.7361 5C12.7361 3.93913 12.3068 2.92172 11.5427 2.17157C10.7786 1.42143 9.74225 1 8.66162 1C7.581 1 6.54463 1.42143 5.78051 2.17157C5.01639 2.92172 4.58712 3.93913 4.58712 5C4.58712 6.06087 5.01639 7.07828 5.78051 7.82843C6.54463 8.57857 7.581 9 8.66162 9Z"
              stroke="#1C1D20"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>Войти</p>
        </li>
      </ul>
    </div>
  );
};

export default HeaderMiddle;
